import { Dialog, useTheme } from '@mui/material';
import { useState } from 'react';
import { normalizeText } from 'utils/normalize';
import { SearchInput } from 'v3/shared/components/Inputs/SearchInput';
import { SubtitleLargeBold } from 'v3/shared/typography/SubtitleLarge';
import {
  AlignRowBetween,
  CloseIconStyled,
  Container,
  dialogStyles,
  DividerStyled,
  Footer,
  Header,
  List,
} from './styles';
import { DialogDataSelectProps } from './types';
import { FormControlLabelStyled, RadioStyled } from 'v3/shared/components/Inputs/RadioFormController/styles';
import { SubtitleMedium } from 'v3/shared/typography/SubtitleMedium';
import { useStoreSelector } from 'v3/data/store';
import { FlexButton } from 'v3/shared/components/Button/FlexButton';
import { BodySmallRegular } from 'v3/shared/typography/BodySmall';

export const DialogRadioDataSelect: React.FC<DialogDataSelectProps> = ({
  setOpen,
  open,
  setSelectItem,
  title,
  hideSearch,
}) => {
  const theme = useTheme();
  const [search, setSearch] = useState<string>('');
  const [selectedItem, setSelectedItem] = useState<string>('');

  const { storeList } = useStoreSelector((state) => state.seller);

  const handleClose = () => setOpen(false);

  const containsText = (store: any, searchText: string) => {
    const nameNormalized = normalizeText(store.name);
    const cnpjNormalized = store.cnpj ? normalizeText(store.cnpj) : '';
    const idNormalized = store.id ? normalizeText(store.id) : '';

    const nameMatch = nameNormalized.includes(searchText);
    const cnpjMatch = cnpjNormalized.includes(searchText);
    const idMatch = idNormalized.includes(searchText);

    return nameMatch || cnpjMatch || idMatch;
  };

  const filteredList = search ? storeList.filter((store) => containsText(store, normalizeText(search))) : storeList;

  return (
    <Dialog
      onClose={handleClose}
      open={open}
      maxWidth={false}
      PaperProps={{
        style: dialogStyles(theme),
      }}
    >
      <Container>
        <Header>
          <AlignRowBetween>
            <SubtitleLargeBold>{title}</SubtitleLargeBold>
            <CloseIconStyled onClick={handleClose} />
          </AlignRowBetween>

          {!hideSearch && (
            <SearchInput
              name="search"
              value={search}
              placeholder={'Procurar por nome da loja ou CNPJ'}
              onChange={(value) => setSearch(value)}
              onKeyDown={(event) => {
                if (event.key !== 'Escape') event.stopPropagation();
                if (event.key === 'Backspace') setSearch('');
              }}
            />
          )}
        </Header>

        <List>
          {filteredList.map((store, index) => (
            <FormControlLabelStyled
              id={`${index}`}
              key={`${index}`}
              value={store.id}
              control={
                <RadioStyled
                  inputProps={{ 'data-testid': `radio` }}
                  checked={selectedItem === store.id}
                  onChange={() => {
                    setSelectedItem(store.id);
                  }}
                />
              }
              label={
                <SubtitleMedium>
                  {store.name}{' '}
                  {store.address?.number && (
                    <BodySmallRegular>
                      {store.address?.street}, {store.address?.number} - {store.address?.neighborhood}
                    </BodySmallRegular>
                  )}
                </SubtitleMedium>
              }
              disabled={false}
            />
          ))}
        </List>

        <DividerStyled />

        <Footer>
          <FlexButton
            text="Escolher loja"
            size="small"
            handleClick={() => {
              const selectedStore = storeList.find((store) => store.id === selectedItem);
              setSelectItem(selectedStore?.name || '');
              handleClose();
            }}
          />
        </Footer>
      </Container>
    </Dialog>
  );
};
